module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/231-libya-c16742c5a60a3e34595bd1fd9828285e.svg";